import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { ApiResponse, updateUserBlock } from '~/api';
import { ApiError, EmptyObject } from '~/types';
import useToast from '~/store/useToast';

interface BlockUserMutationVariables {
  isBlocking: boolean;
  groupchat_id: string;
  block_user_id: string;
}

const useUpdateBlockedUserMutation = () => {
  const { showToast } = useToast();
  return useMutation<
    ApiResponse<EmptyObject>,
    ApiError,
    BlockUserMutationVariables
  >({
    mutationFn: async ({
      groupchat_id,
      block_user_id,
      isBlocking,
    }: BlockUserMutationVariables) => {
      return updateUserBlock({ groupchat_id, block_user_id, isBlocking });
    },
    onError: (error) => {
      console.error(error);
      if (error.status === 403) {
        // 유저가 채팅창 멤버가 아닐 경우
        showToast('error', 'You are not a member of this chat room.');
      } else if (error.status === 409) {
        // 신고한 유저가 채팅창 멤버가 아닐 경우
        showToast('error', 'This user is not a member of the chat room.');
      } else {
        showToast(
          'error',
          'cannot update user block status. please try again.',
        );
      }
    },
  });
};

export default useUpdateBlockedUserMutation;
